import { BaseEntity } from "yt-ng-framework";

export class CompanyView extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string  = null;
    SNaziv: string;
    Pib: string = null;
    MaticniBroj: string  = null;
    Mesto: string  = null;
    OdgovornoLiceID: number = null;
    Adresa:string=null;
    PostBroj:string=null;
    Gln:string=null;
    
    Deserialize(input:any){
        this.ID=input.ID;
        this.Naziv=input.Naziv;
        this.SNaziv = input.SNaziv;
        this.Pib=input.Pib;
        this.MaticniBroj=input.MaticniBroj;
        this.Mesto=input.Mesto;
        this.OdgovornoLiceID = input.OdgovornoLiceID;
        this.Adresa=input.Adresa;
        this.PostBroj=input.PostBroj;
        this.Gln=input.Gln;
        return this;
    }

    Serialize(input:CompanyView){
        return input;
    }
}